type TLoaderProps = React.ComponentPropsWithoutRef<"span">;
const Loader = (props: TLoaderProps) => {
  return (
    <div
      className={`h-5 w-5 border-2 border-current rounded-full border-b-transparent animate-spin ${props.className}`}
    />
  );
};

export default Loader;
